import { FC } from "react";
import { IconPropsType } from ".";

export const CreditDetail: FC<IconPropsType> = (props) => {
  return (
    <svg
      width={props.size ?? "16"}
      height={props.size ?? "16"}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.11111 6.66587C5.11111 7.52498 4.41467 8.22143 3.55556 8.22143C2.69645 8.22143 2 7.52498 2 6.66587C2 5.80676 2.69645 5.11032 3.55556 5.11032C4.41467 5.11032 5.11111 5.80676 5.11111 6.66587Z"
        fill={props.color ?? "#555555"}
      />
      <path
        d="M5.11111 10.814C5.11111 11.6731 4.41467 12.3696 3.55556 12.3696C2.69645 12.3696 2 11.6731 2 10.814C2 9.95491 2.69645 9.25846 3.55556 9.25846C4.41467 9.25846 5.11111 9.95491 5.11111 10.814Z"
        fill={props.color ?? "#555555"}
      />
      <path
        d="M5.11111 14.9622C5.11111 15.8213 4.41467 16.5177 3.55556 16.5177C2.69645 16.5177 2 15.8213 2 14.9622C2 14.1031 2.69645 13.4066 3.55556 13.4066C4.41467 13.4066 5.11111 14.1031 5.11111 14.9622Z"
        fill={props.color ?? "#555555"}
      />
      <path
        d="M8.74074 4.5918C7.88163 4.5918 7.18519 5.28824 7.18519 6.14735C7.18519 7.00646 7.88163 7.70291 8.74074 7.70291H24.2963C25.7281 7.70291 26.8889 8.86365 26.8889 10.2955V11.8511H9.77778C8.91867 11.8511 8.22222 12.5475 8.22222 13.4066C8.22222 14.2657 8.91867 14.9622 9.77778 14.9622L26.8889 15.0813V21.7029C26.8889 23.1348 25.7281 24.2955 24.2963 24.2955H7.7037C6.27186 24.2955 5.11111 23.1348 5.11111 21.7029V20.5177C5.11111 19.6586 4.41467 18.9622 3.55556 18.9622C2.69645 18.9622 2 19.6586 2 20.5177V21.7029C2 24.853 4.55363 27.4066 7.7037 27.4066H24.2963C27.4464 27.4066 30 24.853 30 21.7029V10.2955C30 7.14543 27.4464 4.5918 24.2963 4.5918H8.74074Z"
        fill={props.color ?? "#555555"}
      />
    </svg>
  );
};
